import React, { useCallback, useMemo } from "react";
import { Button, Typography, Paper } from "mpulse-design-system";
import { useDropzone } from "react-dropzone";

const baseStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "20px",
  borderWidth: 2,
  borderRadius: 2,
  borderColor: "#eeeeee",
  borderStyle: "dashed",
  backgroundColor: "#fafafa",
  transition: "border .3s ease-in-out",
};

const activeStyle = {
  borderColor: "#2196f3",
};

const acceptStyle = {
  borderColor: "#00e676",
};

const rejectStyle = {
  borderColor: "#ff1744",
};

const DropzoneComponent = ({
  setFilesUploaded,
  setFilesRejected,
  audioFileMap,
}) => {
  const audioFileValidator = (file) => {
    const fileSplit = file.name.split("."),
      extension = fileSplit.pop(),
      baseName = fileSplit.pop();

    if (extension !== "wav" && extension !== "mp3") {
      return {
        code: "invalid-file-type",
        message: `${file.name} is not a WAV or MP3`,
      };
    } else if (!(baseName in audioFileMap)) {
      return {
        code: "unexpected-file",
        message: `${file.name} is not a file we're expecting`,
      };
    }
    return null;
  };
  const onDrop = useCallback(async (acceptedFiles, rejectedFiles) => {
    setFilesUploaded(acceptedFiles);
    setFilesRejected(rejectedFiles);
  }, []);

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    onDrop,
    maxFiles: 50,
    validator: audioFileValidator,
  });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept]
  );

  return (
    <section>
      <Paper>
        <div
          {...getRootProps({
            style,
          })}
        >
          <input {...getInputProps()} />
          {
            <>
              <Typography variant="subtitle1" color="text.primary">
                Drag & Drop Your files here
              </Typography>
              <Typography variant="subtitle1" color="text.primary">
                {" "}
                or{" "}
              </Typography>
              <Button variant="outline" size="small">
                Choose file
              </Button>
            </>
          }
        </div>
      </Paper>
    </section>
  );
};

export default DropzoneComponent;
